import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { OrderCheckoutComponent } from './order-checkout/order-checkout/order-checkout.component'

import { ShipingDetailsComponent } from './order-checkout/shiping-details/shiping-details.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CustomerDetailComponent } from './order-checkout/customer-detail/customer-detail.component'
import { ShipmentMethodComponent } from './order-checkout/shipment-method/shipment-method.component'
import { NotificationAttachmentComponent } from './order-checkout/notification-attachment/notification-attachment.component'

import { MatExpansionModule } from '@angular/material/expansion'
import { OrderReviewComponent } from './order-review/order-review.component'
import { AddressDetailComponent } from './order-review/address-detail/address-detail.component'
import { LineItemComponent } from './order-review/line-item/line-item.component'
import { ShipingComponent } from './order-review/shiping/shiping.component'
import { BillingDetailsComponent } from './order-review/billing-details/billing-details.component'

import { NotificationComponent } from './order-review/notification/notification.component'
import { OrderReviewModelComponent } from './order-review/order-review-model/order-review-model.component'
import { DIALOG_TYPE, MediaModule, SpinnerModule } from '@spartacus/storefront'
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component'
import { I18nModule, ConfigModule, provideConfig } from '@spartacus/core'
import { RouterModule } from '@angular/router'
import { NgSelectModule } from '@ng-select/ng-select'
import { ComplianceQuestionsDialogModule } from '../../../../shared/dialog-box/compliance-questions-dialog/compliance-questions-dialog.module'
import { environment } from '../../../../../environments/environment'
import { AutoFillNoDialogComponent } from '../../../../shared/dialog-box/compliance-questions-dialog/auto-fill-no-dialog/auto-fill-no-dialog.component'
import { AddressModule } from '../../../../shared/components/address/address.module'
import { ComponentLibraryWrapperModule } from '../../../../component-library-wrapper.module'
import { VS_LAUNCH_CALLER } from '../../../config/dialog.config'

@NgModule({
  declarations: [
    OrderCheckoutComponent,
    ShipingDetailsComponent,
    CustomerDetailComponent,
    ShipmentMethodComponent,
    NotificationAttachmentComponent,
    OrderReviewComponent,
    AddressDetailComponent,
    LineItemComponent,
    NotificationComponent,
    ShipingComponent,
    BillingDetailsComponent,
    OrderReviewModelComponent,
    OrderConfirmationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    AddressModule,
    MediaModule,
    I18nModule,
    RouterModule,
    NgSelectModule,
    SpinnerModule,
    ComponentLibraryWrapperModule,
    ComplianceQuestionsDialogModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['orderCheckOut'],
        },
      },
    }),
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.ORDER_REVIEW]: {
          inlineRoot: true,
          component: OrderReviewModelComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.AUTOFILL_NO]: {
          inlineRoot: true,
          component: AutoFillNoDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [OrderCheckoutComponent, OrderReviewComponent],
})
export class OrderCheckoutModule {}
